import {OnlyCyrillicValidator} from '@spa/validators';

import {BaseControl} from '../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../app/shared/enums';

export const LocalizedDetailFirstNameSelector = 'firstName';
export const LocalizedDetailMiddleNameSelector = 'middleName';
export const LocalizedDetailLastNameSelector = 'lastName';
export const LocalizedDetailStateSelector = 'state';
export const LocalizedDetailCitySelector = 'city';
export const LocalizedDetailAddressSelector = 'address';

export const LocalizedDetailsControls = (): BaseControl<string | number>[] => {
    return [
        new BaseControl({
            name: LocalizedDetailFirstNameSelector,
            value: '',
            placeholder: 'First name',
            validators: [OnlyCyrillicValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: LocalizedDetailMiddleNameSelector,
            value: '',
            placeholder: 'Middle name',
            validators: [OnlyCyrillicValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: LocalizedDetailLastNameSelector,
            value: '',
            placeholder: 'Last name',
            validators: [OnlyCyrillicValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: LocalizedDetailStateSelector,
            value: '',
            placeholder: 'State',
            validators: [OnlyCyrillicValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: LocalizedDetailCitySelector,
            value: '',
            placeholder: 'City',
            validators: [OnlyCyrillicValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: LocalizedDetailAddressSelector,
            value: '',
            placeholder: 'Address',
            validators: [OnlyCyrillicValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
    ];
};
